// Copyright (c) 2022 by Move Closer

import { ValidationRules } from '../../../shared/molecules/Form'

// import { passwordRexExp } from '../../../../contexts'

// const validatePassword = (password: string): ValidationPayload => {
//   let isValid: boolean = true
//   const errors: string[] = []
//
//   /**
//    * PASSWORD MUST CONTAIN, AT LEAST:
//    *** 8 characters
//    *** one letter
//    *** one number
//    *** one special character
//    * @see passwordRexExp
//    */
// if (password.match(passwordRexExp)) {
//     isValid = false
//     const instance = getCurrentInstance()
//
//     if (instance) {
//       errors.push(String(instance.proxy.$t('front.profile.organisms.changePasswordForm.validationError')))
//     }
//   }
//
//   return {
//     isValid,
//     errors
//   }
// }

export const changePasswordFormValidatorsMap: ValidationRules = {
  password: 'required|string|min:6',
  newPassword: 'required|string|min:6'
}
